/**
 * This is Francis Bouvier's HTML compile. It takes some HTML you wish to insert into the page and does an AngularJS
 * compile on it after doing so. That comes in really handy when you're creating your HTML via string concatenation,
 * Handlebars, etc. but you still want AngularJS to provide bindings and controls.
 *
 */
export default function HtmlCompileDirective($compile) {
  'ngInject';
  return {
    restrict: 'A',
    controller: function ($scope, $element, $attrs) {
      'ngInject';
      $scope.$watch($attrs.htmlCompile, function (newValue: any, oldValue) {
        $element.html(newValue);

        $compile($element.contents())($scope);
      });
    }
  };
}
